// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e3vy","left":"styles_left__2ZTQt"};